<template>
	<div>
		<div class="actDiv">
			<a-input-search placeholder="请输入自来水公司名称" enter-button @search="queryDataList" v-model="name" 
									  style="width: 20rem;margin-right: 0.625rem;"/>
			<a-button  icon="plus" @click="addWindowFlag = true">新增水司</a-button>
		</div>
		<a-table  size="small" :columns="columns" :data-source="list" bordered :loading="loading"  rowKey="pid" 
					:pagination="false" :scroll="{y:600}">
			<span slot="theAction" slot-scope="text, record">
			      <a-button size="small"  type="link" @click="editContent(record)">修改</a-button>
			</span>
		</a-table>
		<a-drawer title="修改自来水公司信息" :visible="editWindowFlag"  width="500" @close="onEditClose" :destroyOnClose='true' :maskClosable="false">
			<EditWaterCompany :theEditObj="theEditObj" @cancelEdit="onEditClose" @refreshList="queryDataList"/>
		</a-drawer>
		<a-drawer title="新增自来水公司" :visible="addWindowFlag"  width="500" @close="onAddClose" :destroyOnClose='true' :maskClosable="false">
			<AddWaterCompany @cancelAdd="onAddClose" @refreshList="queryDataList"/>
		</a-drawer>
	</div>
</template>

<script>
	const columns = [
		{
			title: '公司名',
			dataIndex: 'companyName',
			width:150,
			ellipsis:true,
			className:'v-cell',
			align:'center',
		},
		{
			title: '公司地址',
			dataIndex: 'companyAddr',
			width:150,
			ellipsis:true,
			className:'v-cell',
			align:'center',
		},
		{
			title: '公司标识',
			dataIndex: 'mark',
			width:80,
			ellipsis:true,
			className:'v-cell',
			align:'center',
		},
		{
			title: '邮箱主机',
			dataIndex: 'emailHost',
			width:110,
			ellipsis:true,
			className:'v-cell',
			align:'center',
		},
		{
			title: '邮箱用户名',
			dataIndex: 'emailUser',
			width:110,
			className:'v-cell',
			align:'center',
		},
		{
			title: '查询电话',
			dataIndex: 'telephone',
			width:80,
			ellipsis:true,
			className:'v-cell',
			align:'center',
		},
		{
			title: '缴费地址',
			dataIndex: 'payAddr',
			width:180,
			ellipsis:true,
			className:'v-cell',
			align:'center',
		},
		{
			title:'备注',
			dataIndex:'remark',
			width:130,
			ellipsis:true,
			className:'v-cell',
			align:'center',
		},
		{
		    title: '操作',
		    key: 'pid',
		    scopedSlots: { customRender: 'theAction' },
			width:50,
			align:'center',
			className:'v-cell',
			align:'center',
		  },
	];
	import EditWaterCompany from '../components/EditWaterCompany.vue'
	import AddWaterCompany from '../components/AddWaterCompany.vue'
	export default{
		components:{
			EditWaterCompany,
			AddWaterCompany,
		},
		data(){
			return{
				name:'',
				list:[],
				loading:true,
				pagination:null,
				columns,
				editWindowFlag:false,
				addWindowFlag:false,
				theEditObj:{},
			}
		},
		methods:{
			queryDataList:function(){
				let url = this.Api.getLastUrl(this.Api.WATER_COMPANY_LIST_URL);
				let param = {name:this.name};
				this.Api.fetchPostWithForm(url,param).then((data)=>{
					this.loading = false;
					let code = data.data.code;
					let result = data.data.result;
					let msg = data.data.message;
					if(code == this.Api.HTTP_OK_CODE){
						this.list = result;
					}else{
						this.$message.error(msg);
					}
				}).catch((error)=>{
					this.loading = false;
					console.log(error);
				});
			},
			editContent:function(item){
				this.theEditObj = this.Config.deepClone(item);
				this.editWindowFlag = true;
			},
			onEditClose:function(){
				this.editWindowFlag = false;
			},
			onAddClose:function(){
				this.addWindowFlag = false;
			}
		},
		created() {
			this.queryDataList();
		}
	}
</script>

<style>
	.actDiv{
		display: flex;
		flex-direction: row;
		align-items: center;
		margin-bottom: 0.5rem;
		padding: 0 0.625rem;
		font-size: 0.6875rem;
		flex-wrap: wrap;
		line-height: 2.5rem;
	}
</style>
